import { useState } from "react";
import Obrazac6Prikaz from "./Obrazac6Prikaz";
import Button from "../../../../Custom/Button/Button";
import Dodavanje from "./Dodavanje";
import { useGlobalContext } from "../../../../../Context/Context";

const SIGNATURE_URL = "https://data.nadzor.app/potpis.jpg";

const mapApiToDisplay = (d) => ({
  ...d,
  zaposlen: { id: d.employee_id, name: d.zaposleni_naziv || "" },
  radnoMesto: { id: d.workplace_id, name: d.radno_mesto_naziv || "" },
  teorijaDatum: d.teorija_datum_fmt || "",
  praksaDatum: d.praksa_datum_fmt || "",
  testDatum: d.test_datum_fmt || "",
  zapisnikDatum: d.zapisnik_datum_fmt || "",
  lzoDatum: d.lzo_datum_fmt || "",
  lzo: d.lzo || [],
  prati: d.prati || [],
  mere: (d.mere || []).map(m => ({ ...m, text: m.text_content || m.text || "" })),
  opis: d.opis || "",
  rizici: d.rizici || "",
  uputstva: d.uputstva || "",
});

function Preview({ id, cancel, data: initialData, lookups, onRefresh }) {
  const [data] = useState(() => mapApiToDisplay(initialData));
  const [isEdit, setIsEdit] = useState(false);

  const { dictionary } = useGlobalContext();

  const handleZatvoriAzuriranje = () => {
    setIsEdit(false);
    onRefresh();
  };

  const handleStampaj = () => {
    const el = document.getElementById("print-obrazac6");
    if (!el) return;

    const useSignature = window.confirm("Da li želite da dodate stranicu sa potpisom?");
    let signatureHtml = "";
    if (useSignature) {
      signatureHtml = `<div style="page-break-before:always;"><div id="sig-page" style="width:287mm;height:200mm;margin:0 auto;position:relative;overflow:hidden;background:#fff;"><img id="signature-img" src="${SIGNATURE_URL}" style="position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);display:block;"/></div></div>`;
    }

    const printWindow = window.open("", "_blank");
    if (!printWindow) { alert("Popup blokiran."); return; }

    printWindow.document.write(`
      <html>
        <head>
          <meta charset="utf-8"/>
          <style>
            @page { size: A4 portrait; margin: 10mm; }
            body { margin: 0; padding: 5mm; font-family: sans-serif; font-size: 12px; }
            table { width: 100%; border-collapse: collapse; }
            td { border: 1px solid black; padding: 4px; font-size: 12px !important; vertical-align: top; white-space: pre-line; }
            hr { width: 80%; margin: 0 auto; margin-bottom: 5px; }
          </style>
        </head>
        <body>
          ${el.innerHTML}
          ${signatureHtml}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.onload = () => {
      const doPrint = () => { printWindow.focus(); printWindow.print(); printWindow.close(); };
      const img = printWindow.document.getElementById("signature-img");
      const box = printWindow.document.getElementById("sig-page");
      if (box) {
        const footer = Array.from(printWindow.document.querySelectorAll("div"))
          .find(d => d.textContent?.includes("Саветник/сарадник") && d.textContent?.includes("Послодавац"));
        if (footer) footer.remove();
      }
      if (!img || !box) return doPrint();
      const fitAndPrint = () => {
        const nW = img.naturalWidth || 1; const nH = img.naturalHeight || 1;
        img.style.transform = `translate(-50%, -50%) rotate(${nW > nH ? -90 : 0}deg)`;
        doPrint();
      };
      if (img.complete && img.naturalWidth) fitAndPrint();
      else { img.onload = fitAndPrint; img.onerror = doPrint; }
    };
  };

  if (!data) return null;

  return (
    <>
      {!isEdit && (
        <>
          <style>{`#print-obrazac6 td { font-size: 12px !important; }`}</style>
          <div id="print-obrazac6" style={{ overflowY: "auto", height: "calc(100% - 60px)", background: "white", padding: "40px", border: "1.5px solid #9f9f9f" }}>
            <Obrazac6Prikaz data={data} />
          </div>

          <div style={{ marginTop: "10px", display: "flex", justifyContent: "space-between", gap: "10px" }}>
            <div style={{ display: "flex", gap: "10px" }}>
              <div onClick={handleStampaj}>
                <Button activation={true} style={{ padding: "5px", fontWeight: "bold" }}>
                  {dictionary["stampaj"] || "ШТАМПАЈ"}
                </Button>
              </div>
            </div>
            <div style={{ display: "flex", gap: "10px" }}>
              <div onClick={cancel}>
                <Button activation={true} style={{ padding: "5px", fontWeight: "bold" }}>
                  {dictionary["zatvori"] || "ЗАТВОРИ"}
                </Button>
              </div>
              <div onClick={() => setIsEdit(true)}>
                <Button activation={true} style={{ padding: "5px", fontWeight: "bold" }}>
                  {dictionary["azuriraj"] || "АЖУРИРАЈ"}
                </Button>
              </div>
            </div>
          </div>
        </>
      )}

      {isEdit && (
        <Dodavanje
          handleZatvori={handleZatvoriAzuriranje}
          editData={data}
          sacuvajAzurirano={() => onRefresh()}
          lookups={lookups}
        />
      )}
    </>
  );
}

export default Preview;